import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  createHttpLink
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import "./App.css";

import UserSignups from "./pages/signups/UserSignups";
import Dishes from "./pages/dish/Dishes";
import Cook from "./pages/cook/Cook";
import Login from "./pages/user/components/Login";
import Cooks from './pages/cook/Cooks'
import Feedback from './pages/feedback/Feedback'
import OpenSignups from "./pages/signups/OpenSignups";
import ForAllRoute from "./pages/forAll/ForAllRoute";
import FmbItems from "./pages/fmbItems/FmbItems";
import Profile from "./pages/user/Profile";
import Update from "./pages/user/components/Update";
import Reset from "./pages/user/components/Reset";
import CookLogin from "./pages/cook/CookLogin";
import Miqaat from "./pages/miqaat/Miqaat";
import Event from "./pages/event/Event";
import History from "./pages/history/History";
import Pickup from "./pages/pickup/Pickup";
import ManageEvent from "./pages/event/components/ManageEvent";
import SingleEventRsvp from "./pages/event/components/SingleEventRsvp";
import EditEvent from "./pages/event/components/edit/EditEvent";
import Takhmeen from "./pages/user/components/Takhmeen";
import Pledger from "./components/Pledger";

const httpLink = createHttpLink({
  uri: "/graphql",
});

// SETTING UP THE CONTEXT
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("id_token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <>
          <Routes>
            <Route exact path='/' element={<Login />} />
            <Route path='/login' element={<Login />} />
            <Route exact path="/takhmeen" element={<PrivateRoute><Takhmeen /></PrivateRoute>} />
            <Route exact path="/openMenus" element={<Pledger><PrivateRoute requiredRole="FMB_USER"><OpenSignups /></PrivateRoute></Pledger>} />
            <Route exact path="/thaaliSignups" element={<ForAllRoute />} />
            <Route exact path="/fmbItems" element={<PrivateRoute><FmbItems /></PrivateRoute>} />
            <Route exact path="/mySignups" element={<Pledger><PrivateRoute requiredRole="FMB_USER"><UserSignups /></PrivateRoute></Pledger>} />
            <Route exact path="/history" element={<PrivateRoute><History /></PrivateRoute>} />
            <Route exact path="/pickup" element={<PrivateRoute requiredRole="FMB_USER"><Pickup /></PrivateRoute>} />
            <Route exact path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route exact path="/miqaats" element={<Pledger><PrivateRoute><Miqaat /></PrivateRoute></Pledger>} />
            <Route exact path="/events" element={<Pledger><PrivateRoute><Event /></PrivateRoute></Pledger>} />
            <Route exact path="/dishes" element={<PrivateRoute requiredRole="FMB_ADMIN"><Dishes /></PrivateRoute>} />
            <Route path="/cooks/" element={<PrivateRoute requiredRole="FMB_ADMIN"><Cooks /></PrivateRoute>} />
            <Route path="/cook/:cookId" element={<PrivateRoute requiredRole="FMB_ADMIN"><Cook /></PrivateRoute>} />
            <Route path="/event/:eventId" element={<PrivateRoute><SingleEventRsvp /></PrivateRoute>} />
            <Route path="/editEvent/:eventId" element={<PrivateRoute><EditEvent /></PrivateRoute>} />
            <Route path="/cooklogin/:fullName" element={<CookLogin />} />
            <Route path="/feedback/:menuId" element={<PrivateRoute><Feedback /></PrivateRoute>} />
            <Route path="/update/:memberId" element={<PrivateRoute><Update /></PrivateRoute>} />
            <Route path="/manageEvent/:eventId" element={<PrivateRoute><ManageEvent /></PrivateRoute>} />
            <Route exact path="/reset" element={<Reset />} />
          </Routes>
        </>
      </Router>
    </ApolloProvider>
  );
}

export default App;
